// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Service Import
import websiteContactService from '@src/services/websiteContactService'

export const getData = createAsyncThunk('websiteContacts/getData', async params => {
  const { page, perPage, search, domainName } = params
  const skipCount = (page - 1) * perPage
  const response = await websiteContactService.getWebsiteContacts({
    search,
    domainName,
    skipCount,
    totalCount: perPage
  })
  return {
    params,
    data: response.data.data.items,
    totalCount: response.data.data.totalCount
  }
})

export const websiteContactsSlice = createSlice({
  name: 'websiteContacts',
  initialState: {
    data: [],
    totalCount: 0,
    params: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.params = action.payload.params
      state.totalCount = action.payload.totalCount
    })
  }
})

export default websiteContactsSlice.reducer
